import sign_up from './signUp.json';
import whole_result from './wholeResult.json';

const i18n = {
  sign_up,
  whole_result,
};

export default i18n;
